import emojiFlags from 'emoji-flags';

/* eslint-disable max-len */
/* eslint-disable import/no-unused-modules */
const badges = [
  {
    name: '1kviews',
    description: '1,000+ pageviews',
    emoji: '1️⃣',
    type: 'activity',
    hiddenIf: ['100kviews', '10kviews'],
  },
  {
    name: '10kviews',
    description: '10,000+ pageviews',
    emoji: '🔟',
    type: 'activity',
    hiddenIf: ['100kviews'],
  },
  {
    name: '100kviews',
    description: '100,000+ pageviews',
    emoji: '💯',
    type: 'activity',
  },
  {
    name: '1region',
    description: 'Stay-at-home: Blogged about one region',
    verb: 'Blogging about one region',
    emoji: '🏠',
    type: 'activity',
    hiddenIf: ['12region', '8region', '3region'],
  },
  {
    name: '3region',
    description: 'Tourist: Blogged about 3 regions',
    verb: 'Blogging about 3 regions',
    emoji: '🎒',
    type: 'activity',
    hiddenIf: ['12region', '8region', '5region'],
  },
  {
    name: '5region',
    description: 'Nomad: Blogged about 5 regions',
    verb: 'Blogging about 5 regions',
    emoji: '🐪',
    type: 'activity',
    hiddenIf: ['12region', '8region'],
  },
  {
    name: '8region',
    description: 'Traveler: Blogged about 8 regions',
    verb: 'Blogging about 8 regions',
    emoji: '✈️',
    type: 'activity',
    hiddenIf: ['12region'],
  },
  {
    name: '12region',
    description: 'World traveler: Blogged about 12 regions',
    verb: 'Blogging about 12 regions',
    emoji: '🗺',
    type: 'activity',
  },
  {
    name: '1posts',
    description: 'First post published',
    verb: 'Publishing the first post',
    type: 'activity',
    hiddenIf: ['100posts', '50posts', '20posts', '10posts', '5posts'],
  },
  {
    name: '5posts',
    description: '5 posts published',
    type: 'activity',
    hiddenIf: ['100posts', '50posts', '20posts', '10posts'],
  },
  {
    name: '10posts',
    description: '10 posts published',
    type: 'activity',
    hiddenIf: ['100posts', '50posts', '20posts'],
  },
  {
    name: '20posts',
    description: '20 posts published',
    type: 'activity',
    hiddenIf: ['100posts', '50posts'],
  },
  {
    name: '50posts',
    description: '50 posts published',
    type: 'activity',
    hiddenIf: ['100posts'],
  },
  {
    name: '100posts',
    description: '100 posts published',
    type: 'activity',
  },
  // Account-birthday badges. The bot in tf-bots/src/birthday-bot awards up to
  // the same MAX_YEAR_BADGE = 15 — extend both together. prettier-ignore keeps
  // the hiddenIf ladders readable as one line each.
  // prettier-ignore
  {
    name: '1years',
    description: 'More than 1 year on TravelFeed',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years', '8years', '7years', '6years', '5years', '4years', '3years', '2years'],
  },
  // prettier-ignore
  {
    name: '2years',
    description: 'More than 2 years on TravelFeed',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years', '8years', '7years', '6years', '5years', '4years', '3years'],
  },
  // prettier-ignore
  {
    name: '3years',
    description: 'More than 3 years on TravelFeed',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years', '8years', '7years', '6years', '5years', '4years'],
  },
  // prettier-ignore
  {
    name: '4years',
    description: 'More than 4 years on TravelFeed',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years', '8years', '7years', '6years', '5years'],
  },
  // prettier-ignore
  {
    name: '5years',
    description: 'More than 5 years on TravelFeed',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years', '8years', '7years', '6years'],
  },
  // prettier-ignore
  {
    name: '6years',
    description: 'More than 6 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years', '8years', '7years'],
  },
  // prettier-ignore
  {
    name: '7years',
    description: 'More than 7 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years', '8years'],
  },
  // prettier-ignore
  {
    name: '8years',
    description: 'More than 8 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years', '9years'],
  },
  // prettier-ignore
  {
    name: '9years',
    description: 'More than 9 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years', '10years'],
  },
  // prettier-ignore
  {
    name: '10years',
    description: 'More than 10 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years', '11years'],
  },
  // prettier-ignore
  {
    name: '11years',
    description: 'More than 11 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years', '12years'],
  },
  // prettier-ignore
  {
    name: '12years',
    description: 'More than 12 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years', '13years'],
  },
  // prettier-ignore
  {
    name: '13years',
    description: 'More than 13 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years', '14years'],
  },
  // prettier-ignore
  {
    name: '14years',
    description: 'More than 14 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
    hiddenIf: ['15years'],
  },
  {
    name: '15years',
    description: 'More than 15 years on TravelFeed',
    emoji: '🎂',
    type: 'activity',
  },
  {
    name: 'blogsbeta',
    description: 'Participated in TravelFeed Hosting Beta',
    verb: 'Participating in TravelFeed Hosting Beta',
    emoji: '👨‍💻',
    type: 'event',
  },
  {
    name: 'hosting',
    description: 'Uses TravelFeed Hosting',
    verb: 'Using TravelFeed Hosting',
    emoji: '🖥️',
    type: 'event',
  },
  { name: 'Northern America', emoji: '🌁', type: 'region' },
  { name: 'Central America', emoji: '🏜', type: 'region' },
  { name: 'Caribbean', emoji: '🌴', type: 'region' },
  { name: 'South America', emoji: '💃', type: 'region' },
  { name: 'Middle East', emoji: '🕌', type: 'region' },
  { name: 'Western & Central Asia', emoji: '🏔', type: 'region' },
  { name: 'Southern Asia', emoji: '👳', type: 'region' },
  { name: 'South-Eastern Asia', emoji: '🐘', type: 'region' },
  { name: 'Eastern Asia', emoji: '⛩', type: 'region' },
  { name: 'Africa', emoji: '🐫', type: 'region' },
  { name: 'Oceania', emoji: '🌊', type: 'region' },
  { name: 'Southern Europe', emoji: '🍕', type: 'region' },
  { name: 'Western Europe', emoji: '🥐', type: 'region' },
  { name: 'Eastern Europe', emoji: '🏰', type: 'region' },
  { name: 'Northern Europe', emoji: '🌲', type: 'region' },
];

export const getBadge = (badgeType, badgeName) => {
  let badge;
  if (badgeType === 'country') {
    if (badgeName === 'xk')
      badge = {
        code: 'XK',
        emoji: '🇽🇰',
        unicode: 'U+1F1FD U+1F1F0',
        name: 'Kosovo',
        title: 'flag for Kosovo',
        dialCode: '+383',
      };
    else badge = emojiFlags.countryCode(badgeName.toUpperCase());
  } else {
    badges.forEach(onebadge => {
      if (onebadge.name === badgeName && onebadge.type === badgeType)
        badge = onebadge;
    });
  }
  return badge;
};

export const checkBadgeHidden = (badgeType, badgeName, allBadges) => {
  let badge;
  if (badgeType !== 'activity') return false;
  badges.forEach(onebadge => {
    if (onebadge.name === badgeName && onebadge.type === badgeType)
      badge = onebadge;
  });
  if (!badge) return true;
  let result = false;
  if (badge.hiddenIf) {
    badge.hiddenIf.forEach(hideThis => {
      allBadges.forEach(badgeOwned => {
        if (badgeOwned.type === 'activity' && badgeOwned.name === hideThis) {
          result = true;
        }
      });
    });
  }
  return result;
};
